import { render, staticRenderFns } from "./LiveActivityFeed.vue?vue&type=template&id=a07a5e7a&scoped=true"
import script from "./LiveActivityFeed.vue?vue&type=script&lang=js"
export * from "./LiveActivityFeed.vue?vue&type=script&lang=js"
import style0 from "./LiveActivityFeed.vue?vue&type=style&index=0&id=a07a5e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07a5e7a",
  null
  
)

export default component.exports